import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function PrivateRoute({ children }) {
  const { user } = useSelector((state) => state.auth);
  const token = localStorage.getItem('accessToken');

  if (!user && !token) {
    return <Navigate to="/login" replace />;
  }

  return children;
}
